import { useContext } from 'react'
import { Context } from './CategoriesContext'
export const useCategoriesContext = () => useContext(Context)
export default useCategoriesContext